import { useState, useEffect } from "react";
import { useProfile } from "../../../services/hooks/getAdminapis";
import { ShimmerThumbnail } from "react-shimmer-effects";

const ProfileTab = () => {
  const [activeSection, setActiveSection] = useState("");
  const [data, setData] = useState({
    crypto: null,
    bank: null,
    upi: null,
  });
  const [fetchLoading, setFetchLoading] = useState(true);

 

  //   ======getting profile data====
  const { data: profile, isLoading } = useProfile();

  useEffect(() => {
    if (!isLoading) {
      setFetchLoading(false);
    }
  }, [isLoading]);
  // console.log("Profile Data:....................................", profile);

  //    console.log("Profile Data:", profile);
  return (
    <>
      {fetchLoading ? (
        <div className="shimmer-container">
          <div className="shimmer-effect">
            <ShimmerThumbnail row={2} col={2} card frameHeight={1000} />
          </div>
        </div>
      ) : (
        <div className="container mt-4">
          <h5 className="text-uppercase">Personal Information</h5>
          <div className="personal-info">
            <p>
              <strong>Full Name:</strong> {profile?.FullName || "..."}
            </p>
            <p>
              <strong>Email:</strong> {profile?.Email || "..."}
            </p>
            <p>
              <strong>Phone Number:</strong> {profile?.Phone || "..."}
            </p>
            <p>
              <strong>Admin ID:</strong> {profile?.AdminID || "..."}
            </p>
            <p>
              <strong>Role:</strong> {profile?.Role || "..."}
            </p>
            <p>
              <strong>Total-Users Handling:</strong> {profile?.totalUsersHandling || "..."}
            </p>
          </div>{" "}
        </div>
      )}
    </>
  );
};

export default ProfileTab;
